import React, { Component } from 'react';
import TypeWriter from 'react-typewriter';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Text } from './common';

@observer
export default class Typewriter extends Component {
  @observable currentIdx = 0;
  @observable direction = 1;
  end = () => {
    const { data, loop, onEnd } = this.props;
    console.log('end');
    if (this.direction === 1) {
      this.direction = -1;
    } else {
      this.direction = 1;
      if (this.currentIdx >= data.length - 1) {
        if (loop) {
          this.currentIdx = 0;
        } else {
          this.direction = 0;
          onEnd && onEnd();
        }
      } else {
        this.currentIdx += 1;
      }
    }
  };
  render() {
    const { data, styles, on } = this.props;
    console.log('typewriter render');
    return (
      <TypeWriter
        typing={on ? this.direction : 0}
        className={styles}
        fixed
        minDelay={this.direction > 0 ? 200 : 50}
        onTypingEnd={this.end}
      >
        <Text t-lxxx white>
          {data[this.currentIdx]}
        </Text>
      </TypeWriter>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_new/Typewriter.js